import { useId, useState } from 'react';
import { useAppStore } from '../../store/useAppStore';
import { Dialog } from './Dialog';

interface GlossaryPopoverProps {
  termId: string;
}

/** Zeigt einen Glossarbegriff als anklickbaren Begriff mit verständlicher Erklärung (Abschnitt 27). */
export function GlossaryPopover({ termId }: GlossaryPopoverProps) {
  const [open, setOpen] = useState(false);
  const titleId = useId();
  const glossary = useAppStore((state) => state.dataModel.glossary);
  const entry = glossary.find((term) => term.id === termId);

  if (!entry) return null;

  return (
    <>
      <button type="button" className="glossary-term" onClick={() => setOpen(true)}>
        {entry.term}
      </button>
      <Dialog open={open} onClose={() => setOpen(false)} titleId={titleId} title={entry.term}>
        <p>{entry.simpleDefinition}</p>
        {entry.avoid && (
          <p>
            <strong>Nicht gemeint:</strong> {entry.avoid}
          </p>
        )}
        {entry.note && <p>{entry.note}</p>}
      </Dialog>
    </>
  );
}
